// reducers/edgesReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

export const edgesslice = createSlice({
  name: "edges",
  initialState: {
    edgess: [],
  },
  reducers: {
    seteditedNewEdges: (state, action) => {
      // //// console.log(action.payload);
      // Only update if data actually changed
      if (state.edgess !== action.payload) {
        state.edgess = action.payload;
      }
    },
    AddNewedges: (state, action) => {
      state.edgess = [...state.edgess, action.payload];
    },
    AddNewnedgeArray: (state, action) => {
      // Use utility function to combine and format nodes
      // state.edgess = formatAndCombineNodes(state.edgess, action.payload);
      state.edgess = [...state.edgess, ...action.payload]
    },
    updateedgess: (state, action) => {
      let data = action.payload;
      let index = state.edgess.findIndex(
        (obj) => obj._id.toString() === data._id.toString()
      );
      if (index !== -1) {
        state.edgess[index] = data;
      }
    },
    deleteedge: (state, action) => {
      const { edgesId, commentId } = action.payload;
      let edgesIndex = state.edgess.findIndex(
        (edges) => edges._id.toString() === edgesId.toString()
      );
      if (edgesIndex !== -1) {
        let comments = state.edgess[edgesIndex].comments;
        const updatedComments = comments.filter(
          (comment) => comment._id.toString() !== commentId.toString()
        );
        state.edgess[edgesIndex].comments = updatedComments;
      }
    },
    deleteedges: (state, action) => {
      let id = action.payload;
      const updatededgess = state.edgess.filter(function (edges) {
        return edges._id !== id;
      });
      state.edgess = updatededgess;
    },
    editComment: (state, action) => {
      const { edgesId, commentId, text } = action.payload;
      let edgesIndex = state.edgess.findIndex(
        (edges) => edges._id.toString() === edgesId.toString()
      );
      if (edgesIndex !== -1) {
        let commentIndex = state.edgess[edgesIndex].comments.findIndex(
          (comment) => comment._id.toString() === commentId.toString()
        );
        if (commentIndex !== -1) {
          state.edgess[edgesIndex].comments[commentIndex].text = text;
        }
      }
    },
    edgesSliceLogout: (state) => {
      state.edgess = [];
    },
  },
});

// Memoized selector - prevents unnecessary re-renders
export const selectedgess = createSelector(
  [(state) => state.edges.edgess],
  (edgess) => edgess,
  {
    memoizeOptions: {
      equalityCheck: (a, b) => {
        // Quick reference check
        if (a === b) return true;
        // Compare lengths
        if (!a || !b || a.length !== b.length) return false;
        // Compare source/target only (fast check)
        return a.every((edge, i) => 
          edge?.source === b[i]?.source && edge?.target === b[i]?.target
        );
      }
    }
  }
);

export const {
  seteditedNewEdges,
  AddNewnedgeArray,
  updateedgess,
  deleteedge,
  AddNewedges,
  deleteComment,
  editComment,
  edgesSliceLogout,
} = edgesslice.actions; // actions
export default edgesslice.reducer;
